import { useNavigate } from 'react-router-dom';
import { Card } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';
import PageHeader from '@/shared/components/PageHeader';
import PropertyAmenityForm from '../components/PropertyAmenityForm';
import { useCreatePropertyAmenity } from '../hooks/usePropertyAmenityMutations';

export default function PropertyAmenityCreatePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mutation = useCreatePropertyAmenity();
  const handleSubmit = (data: any) => { mutation.mutate(data, { onSuccess: () => navigate('/property-amenities') }); };
  return (
    <div>
      <PageHeader back title={t('propertyAmenities.addTitle')} subtitle={t('propertyAmenities.addSubtitle')} />
      <Card><PropertyAmenityForm onSubmit={handleSubmit} isLoading={mutation.isPending} /></Card>
    </div>
  );
}
